import React from 'react'
import styles from './Form.module.css'

const Field = ({ name, placeholder, type, handleChange, defaultValue }) => {

    return (
        <div>
            <input 
                className={styles.inputField} 
                type={type}
                name={name}
                defaultValue={defaultValue}
                placeholder={placeholder}
                onChange={handleChange} 
                required = {true}
            />
        </div>
    )
}

export default Field
